import { setPopupProps, openPopup } from './popupReducer';
export var openAlertPopup = function(componentProps) {
    return function(dispatch) {
        dispatch(setPopupProps({
            componentName: 'AlertPopup',
            componentProps: componentProps
        }));
        dispatch(openPopup());
    };
};
